import { Injectable } from '@angular/core';
import {
  AccessTokenResponse,
  AuthenticateVleUserSilentlyConfig,
  LoginResponse,
  PersonaConfig,
  RedirectAuthLoginResponse,
  RefreshAccessTokenConfig,
  authenticateViaBreakout,
  authenticateVleUserSilently,
  authenticateVleUserViaBreakout,
  completeRedirectAuthentication,
  initiateRedirectAuthentication,
  refreshAccessToken,
  silentlyAuthenticate,
} from '@technologyfromsage/persona-padlock';
import { Observable, from } from 'rxjs';

export interface RedirectAuthAppState {
  target: string;
  tenantCode: string;
}

@Injectable()
export class PersonaPadlockService {
  public initiateRedirectAuthentication(
    config: PersonaConfig,
    redirectUri: string,
    appState?: any,
  ): void {
    initiateRedirectAuthentication(config, redirectUri, appState);
  }

  public completeRedirectAuthentication(): Observable<
    RedirectAuthLoginResponse<RedirectAuthAppState>
  > {
    return from(completeRedirectAuthentication<RedirectAuthAppState>());
  }

  public refreshAccessToken(
    config: RefreshAccessTokenConfig,
  ): Observable<AccessTokenResponse> {
    return from(refreshAccessToken(config));
  }

  public silentlyAuthenticate(
    config: PersonaConfig,
    bypassFirstPartyCheck = false,
  ): Observable<LoginResponse> {
    return from(silentlyAuthenticate(config, bypassFirstPartyCheck));
  }

  public authenticateViaBreakout(
    config: PersonaConfig,
  ): Observable<LoginResponse> {
    return from(authenticateViaBreakout(config));
  }

  public authenticateVleUserSilently(
    ltiConfig: AuthenticateVleUserSilentlyConfig,
  ): Observable<LoginResponse> {
    return from(authenticateVleUserSilently(ltiConfig));
  }

  public authenticateVleUserViaBreakout(
    config: PersonaConfig,
  ): Observable<LoginResponse> {
    return from(authenticateVleUserViaBreakout(config));
  }
}
